import { css } from 'styled-components'
import { colors } from 'const/colors'
import { useEffect } from 'react'

export const ActiveSubMenuCSS = css`
  border-bottom: 2px solid ${({ theme }) => theme.menu.border};
  padding-bottom: 10px;
  color: ${({ theme }) => theme.menu.text};
  padding-left: 13px;
`

export const ExpandMenuCSS = css`
  background-color: ${colors.greyThirty};
  border-bottom: 2px solid ${({ theme }) => theme.menu.border};
`

export const MenuTextButtonCSS = css`
  color: ${({ theme }) => theme.menu.text};
  font-weight: 600;
`

export const MobileSubMenuItemCSS = css`
  margin: 0;
  font-size: 12px;
  text-transform: uppercase;
`

export const ActiveBorderCSS = css`
  border-color: ${({ theme }) => theme.menu.border} transparent;
`

export const MenuLinkCSS = css`
  font-weight: 600;
  color: ${({ theme }) => theme.menu.text};
`

/**
 * This event listener hook, listens to esc key press when the
 * submenu item container is active and closes the submenu item container
 */
export const useEscapeKeyDownListener = ({
  handleOnEscape,
  ref,
  isMenuExpanded
}: {
  handleOnEscape: () => void
  ref: React.RefObject<HTMLButtonElement>
  isMenuExpanded: boolean
}) => {
  const escapeKeyEventListener = () => {
    const onEscapeKeyHandler = (event: { key: string }) => {
      const closeMenuKey = ['escape']
      if (closeMenuKey.includes(event.key.toLowerCase())) {
        ref.current?.focus()
        handleOnEscape()
      }
    }
    if (isMenuExpanded) {
      window.addEventListener('keydown', onEscapeKeyHandler)
    } else {
      window.removeEventListener('keydown', onEscapeKeyHandler)
    }
    return () => {
      window.removeEventListener('keydown', onEscapeKeyHandler)
    }
  }
  return useEffect(escapeKeyEventListener, [
    handleOnEscape,
    isMenuExpanded,
    ref
  ])
}
